import { getHistory } from '../routing/history';
export const setNewRelicCustomAttributes = () => {
  const queryParams = new URLSearchParams(getHistory().location.search);
  const isEmbedded = Boolean(queryParams.get('_seia'));
  if (window.newrelic) {
    window.newrelic.setCustomAttribute('is-embedded', isEmbedded);
  }
};